import React, { useContext, useEffect } from "react";
import trans from "../../../../utils";
import { InputPermissions } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { Switch } from "antd";
import {
	useGetActionQuery,
	useGetModulesQuery,
	useGetResourcesQuery,
	useGetSubModulesQuery,
} from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import { popupcontext } from "../../../../context/Popupscontext";

export default function PermissionsAccess({ addData }) {
	let { isEditing } = useContext(popupcontext);
	const modules = [
		{ label: trans("Field Staff"), value: "FIELD_STAFF" },
		{ label: trans("Fleet management & Live tracking"), value: "TRACKING" },
	];
	const resources = [
		{ label: trans("Vehicle"), value: "VEHICLE" },
		{ label: trans("Driver"), value: "DRIVER" },
		{ label: trans("User"), value: "USER" },
		{ label: trans("Task"), value: "TASK" },
		{ label: trans("Group"), value: "GROUP" },
		{ label: trans("Route"), value: "ROUTE" },
	];
	const actions = [
		{ label: trans("Add"), value: "ADD" },
		{ label: trans("Edit"), value: "EDIT" },
		{ label: trans("Delete"), value: "DELETE" },
		{ label: trans("View"), value: "VIEW" },
	];

	const submodules = {
		fieldstaff: [
			{ label: trans("POI"), value: "POI" },
			{ label: trans("Form"), value: "FORM" },
			{ label: trans("Task"), value: "TASK" },
		],
		tracking: [
			{ label: trans("Setup"), value: "SETUP" },
			{ label: trans("Group"), value: "GROUP" },
			{ label: trans("Route"), value: "ROUTE" },
		],
	};
	const userType = [
		{ label: trans("Supervisor"), value: "SUPERVISOR" },
		{ label: trans("Field Staff"), value: "FIELD_STAFF" },
		{ label: trans("Customer"), value: "CUSTOMER" },
	];
	const { data: modulesData } = useGetModulesQuery();
	const { data: submodulesData } = useGetSubModulesQuery(
		{ module: addData.values.modules },
		{ skip: !addData.values.modules }
	);
	const { data: resourcesData } = useGetResourcesQuery(
		{ submodule: addData.values.submodules },
		{ skip: !addData.values.submodules }
	);
	const { data: actionsData } = useGetActionQuery(
		{ resource: addData.values.resources },
		{ skip: !addData.values.resources }
	);

	return (
		<>
			<div className="userinfo mb-24">
				<p className="fs-16 fw-700 brand-700 text-uppercase">
					{trans("access control")}
				</p>
				<div className="row">
					<div className="col-lg-6">
						<InputPermissions
							title={trans("Module")}
							type="module"
							formstyle="form-input"
							data={modulesData?.data?.map((i) => ({
								label: trans(i.label),
								value: i.value,
							}))}
							id="modules"
							name="modules"
							onBlur={addData.handleBlur}
							onChange={(e) => {
								addData.setFieldValue("modules", e ?? null);
								addData.setFieldValue("submodules", [], false);
								addData.setFieldTouched("submodules", false, false);

								addData.setFieldValue("resources", null, false);
								addData.setFieldTouched("resources", false, false);

								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
							onClear={() => {
								addData.setFieldValue("submodules", [], false);
								addData.setFieldTouched("submodules", false, false);

								addData.setFieldValue("resources", null, false);
								addData.setFieldTouched("resources", false, false);

								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
							errors={addData.errors.modules}
							touched={addData.touched.modules}
							value={addData.values.modules || undefined}
						/>
					</div>
					<div className="col-lg-6">
						<InputPermissions
							title={trans("Sub Module")}
							type="sub-module"
							formstyle="form-input"
							id="submodules"
							name="submodules"
							data={submodulesData?.data?.map((i) => ({
								label: trans(i.label),
								value: i.value,
							}))}
							disabled={!addData.values.modules}
							onBlur={addData.handleBlur}
							onChange={(e) => {
								addData.setFieldValue("submodules", [e]);
								addData.setFieldValue("resources", null, false);
								addData.setFieldTouched("resources", false, false);

								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
							errors={addData.errors.submodules}
							touched={addData.touched.submodules}
							value={addData.values?.submodules || undefined}
							onClear={() => {
								addData.setFieldValue("resources", null, false);
								addData.setFieldTouched("resources", false, false);

								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
						/>
					</div>
					<div className="col-lg-6">
						<InputPermissions
							title={trans("Resource")}
							type="resource"
							formstyle="form-input"
							data={resourcesData?.data?.map((i) => ({
								label: trans(i.label),
								value: i.value,
							}))}
							id="resources"
							name="resources"
							onBlur={addData.handleBlur}
							onChange={(e) => {
								addData.setFieldValue("resources", e ?? null);
								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
							errors={addData.errors.resources}
							touched={addData.touched.resources}
							value={addData.values.resources || undefined}
							disabled={addData.values?.submodules?.length === 0}
							onClear={() => {
								addData.setFieldValue("actions", null, false);
								addData.setFieldTouched("actions", false, false);
							}}
						/>
					</div>

					<div className="col-lg-6">
						<InputPermissions
							title={trans("Access Type")}
							type="access type"
							formstyle="form-input"
							data={actionsData?.data?.map((i) => ({
								label: trans(i.label),
								value: i.value,
							}))}
							id="actions"
							name="actions"
							onBlur={addData.handleBlur}
							onChange={(e) => addData.setFieldValue("actions", e ?? null)}
							errors={addData.errors.actions}
							touched={addData.touched.actions}
							disabled={!addData.values.resources}
							value={addData.values.actions || undefined}
						/>
					</div>

					<div className="col-lg-6">
						<InputSelect
							label={trans("User Type")}
							type="text"
							placeholder={trans("e.g. Supervisor , Field Staff")}
							formstyle="form-input"
							id="userType"
							name="userType"
							options={userType}
							onChange={(e) => {
								addData.setFieldValue("userType", e ?? null);
							}}
							onBlur={addData.handleBlur}
							errors={addData.errors.userType}
							touched={addData.touched.userType}
							value={addData.values.userType || undefined}
							allowClear={false}
						/>
					</div>
					<div className="col-lg-6">
						<div className={`position-relative form-input`}>
							<label className="form-label text-capitalize d-block mb-2">
								{trans("hierarchical access")}
							</label>
							<Switch
								onChange={(e) =>
									addData.setFieldValue("hierarchical_access", e)
								}
								onBlur={addData.handleBlur}
								value={addData.values.hierarchical_access || undefined}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
